import { create } from 'zustand';

function getTodayValue() {
  return new Date().toISOString().slice(0, 10);
}

const initialFilters = {
  operationId: '',
  placeId: '',
  date: getTodayValue(),
  startTime: '08:00',
  endTime: '09:00',
};

const initialState = {
  filters: initialFilters,
  hasSearchedParticipants: false,
  participantsDisponibles: [],
  participantSearch: '',
  participantsSeleccionados: [],
  charlaId: '',
  observaciones: '',
  evidenciasFoto: [],
  firma: '',
};

function createEvidenciaId() {
  return `ev-${Date.now()}`;
}

export const useToolboxStore = create((set, get) => ({
  ...initialState,
  setOperationId(operationId) {
    set((state) => ({
      filters: {
        ...state.filters,
        operationId,
        placeId: '',
      },
      hasSearchedParticipants: false,
      participantsDisponibles: [],
      participantSearch: '',
      participantsSeleccionados: [],
      charlaId: '',
      observaciones: '',
      evidenciasFoto: [],
      firma: '',
    }));
  },
  setPlaceId(placeId) {
    set((state) => ({
      filters: {
        ...state.filters,
        placeId,
      },
      hasSearchedParticipants: false,
      participantsDisponibles: [],
      participantSearch: '',
      participantsSeleccionados: [],
      charlaId: '',
      observaciones: '',
      evidenciasFoto: [],
      firma: '',
    }));
  },
  setDate(date) {
    set((state) => ({
      filters: {
        ...state.filters,
        date,
      },
    }));
  },
  setStartTime(startTime) {
    set((state) => ({
      filters: {
        ...state.filters,
        startTime,
      },
    }));
  },
  setEndTime(endTime) {
    set((state) => ({
      filters: {
        ...state.filters,
        endTime,
      },
    }));
  },
  buscarParticipantes(participantsDisponibles = []) {
    set({
      hasSearchedParticipants: true,
      participantsDisponibles,
      participantSearch: '',
      participantsSeleccionados: participantsDisponibles,
      charlaId: '',
      observaciones: '',
      evidenciasFoto: [],
      firma: '',
    });
  },
  volverAFiltros() {
    set({
      hasSearchedParticipants: false,
      participantSearch: '',
    });
  },
  setParticipantSearch(participantSearch) {
    set({ participantSearch });
  },
  toggleParticipant(participant) {
    set((state) => {
      const alreadySelected = state.participantsSeleccionados.some(
        (item) => item.id === participant.id
      );

      return {
        participantsSeleccionados: alreadySelected
          ? state.participantsSeleccionados.filter(
              (item) => item.id !== participant.id
            )
          : [...state.participantsSeleccionados, participant],
      };
    });
  },
  setCharlaId(charlaId) {
    set({ charlaId });
  },
  setObservaciones(observaciones) {
    set({ observaciones });
  },
  agregarEvidenciaFoto({ dataUrl, file }) {
    const id = createEvidenciaId();
    set({ evidenciasFoto: [{ id, dataUrl, file }] });
  },
  quitarEvidenciaFoto(id) {
    set((state) => ({
      evidenciasFoto: state.evidenciasFoto.filter((item) => item.id !== id),
    }));
  },
  reemplazarEvidenciaFoto(id, { dataUrl, file }) {
    set((state) => ({
      evidenciasFoto: state.evidenciasFoto.map((item) =>
        item.id === id
          ? { ...item, dataUrl, file, referencia: undefined }
          : item
      ),
    }));
  },
  setFirma(firma) {
    set({ firma });
  },
  resetToolbox() {
    set({
      ...initialState,
      filters: {
        ...initialFilters,
        date: getTodayValue(),
      },
    });
  },
}));
